import React from "react";
import classnames from "classnames";

import { PAGE_NOT_FOUND, SIDE_IMAGE_1, SIDE_IMAGE_2 } from "../../constants";

const SideContent = ({ isOverflow, notFound }) => (
  <div
    className={classnames(
      "d-flex flex-wrap align-items-center position-absolute",
      notFound && "justify-content-center"
    )}
  >
    <img
      className="img-fluid float-left"
      style={{
        height: !isOverflow ? window.innerHeight : window.innerHeight + 180,
        objectFit: "fill",
        zIndex: -1,
      }}
      src={SIDE_IMAGE_1}
      alt="img"
    />
    {notFound ? (
      <img className="position-absolute" src={PAGE_NOT_FOUND} alt="img" />
    ) : (
      <img
        className="position-absolute ml-n5"
        style={{
          top: 89,
        }}
        src={SIDE_IMAGE_2}
        alt="img"
      />
    )}
  </div>
);

export default SideContent;
